export default "__VITE_ASSET__DAhaPFUh__"